import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
// import { environment } from '../../environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { MenuItem } from 'tn-custom-primeng/api';
import { AuthenService, CommonService, UserService } from 'tnx-shared';
import { MenuService } from './service/menu.service';

@Component({
    selector: 'app-menu-mobile',
    templateUrl: './menu-mobile.component.html',
    styleUrls: ['./menu-mobile.component.scss']
})
export class MenuMobileComponent implements OnInit {
    items: MenuItem[];
    status: boolean = false;
    changed: boolean = false;
    readonly CURRENT_USER_KEY = 'current_user_info';
    readonly CURRENT_ORGANIZATION_KEY = 'current_organization_key';

    constructor(
        private service: MenuService,
        private _userService: UserService,
        private _oauthService: OAuthService,
        private _authenService: AuthenService,
        private _router: Router,
        public _commonService: CommonService
    ) { }

    ngOnInit(): void {
        this.items = [
            // { label: 'Trang chủ', routerLink: '/' },
            {
                label: 'Dịch vụ công',
                items: [
                    {
                        label: 'Thủ tục hành chính', routerLink: '/apply-online',
                        icon: 'fa fa-fw fa-gavel'
                    },
                    {
                        label: 'Hồ sơ đã nộp', routerLink: '/management', visible: this.isValidAccesstoken(),
                        icon: 'fa fa-fw fa-address-book'
                    },
                ]
            },
            {
                label: 'Truy xuất nguồn gốc',
                items: [
                    {
                        label: 'Kế hoạch sản xuất', routerLink: '/production-planning', visible: this.isValidAccesstoken(),
                        icon: 'fa fa-fw fa-building'
                    },
                    {
                        label: 'Kê khai thông tin', routerLink: '/production-planning/discover', visible: this.isValidAccesstoken(),
                        icon: 'fa fa-fw fa-info-circle'
                    },
                    {
                        label: 'Truy xuất nguồn gốc', routerLink: '/scan/-1',
                        icon: 'fa fa-fw fa-sitemap'
                    },
                ]
            },
            {
                label: 'Xuất khẩu Trung Quốc',
                items: [
                    {
                        label: 'Kích hoạt tem', routerLink: '/activate-stamp', visible: this.isValidAccesstoken(),
                        icon: 'fa fa-fw fa-sticky-note'
                    },
                    {
                        label: 'Tra cứu lô hàng', routerLink: '/lookup-information',
                        icon: 'fa fa-fw fa-truck'
                    }
                ]
            },
            {
                label: this.getCurrentUserFullName(), visible: this.isValidAccesstoken(),
                items: [{
                    label: 'Thông tin tài khoản',
                    icon: 'fa fa-fw fa-user-circle',
                    command: (event) => {
                        this.onEditInfo(event);
                    }
                },
                {
                    label: 'Quản trị doanh nghiệp',
                    icon: 'fas fa-fw fa-building',
                    // command: () => {
                    //     this.onServiceManagement();
                    // }
                },
                // {
                //     label: 'Quản lý tem',
                //     icon: 'fas fa-fw fa-stamp',
                //     command: () => {
                //         this.stampInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin đơn vị nhập khẩu',
                //     icon: 'fas fa-file-import',
                //     command: () => {
                //         this.importInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin nhân viên',
                //     icon: 'fas fa-fw fa-user-tie',
                //     command: () => {
                //         this.staffInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin sản phẩm',
                //     icon: 'fas fa-fw fa-barcode',
                //     command: () => {
                //         this.productInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin vùng trồng',
                //     icon: 'fas fa-fw fa-seedling',
                //     command: () => {
                //         this.plantingAreaInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin khu',
                //     icon: 'fas fa-fw fa-seedling',
                //     command: () => {
                //         this.khuInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin lô',
                //     icon: 'fas fa-fw fa-seedling',
                //     command: () => {
                //         this.loInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin thửa',
                //     icon: 'fas fa-fw fa-seedling',
                //     command: () => {
                //         this.thuaInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin luống',
                //     icon: 'fas fa-fw fa-seedling',
                //     command: () => {
                //         this.luongInfo();
                //     }
                // },
                // {
                //     label: 'Thông tin phân bón',
                //     icon: 'fas fa-fw fa-prescription-bottle',
                //     command: () => {
                //         this.ferlilizerInfo();
                //     }
                // },
                // {
                //     label: 'Nhập/xuất phân bón',
                //     icon: 'fas fa-fw fa-eye',
                //     command: () => {
                //         this.trackFerlilizer();
                //     }
                // },
                // {
                //     label: 'Thuốc bảo vệ thực vật',
                //     icon: 'fas fa-fw fa-leaf',
                //     command: () => {
                //         this.medicineInfo();
                //     }
                // },
                // {
                //     label: 'Nhập/xuất thuốc BVTV',
                //     icon: 'fas fa-fw fa-eye',
                //     command: () => {
                //         this.trackMedicine();
                //     }
                // },
                {
                    label: 'Đăng xuất',
                    icon: 'fas fa-fw fa-sign-out-alt',
                    command: () => {
                        this.onTopbarLogout();
                    }
                }]
            },
            {
                label: 'Tài khoản', visible: !this.isValidAccesstoken(),
                items: [
                    {
                        label: 'Đăng nhập',
                        icon: 'fas fa-fw fa-sign-in-alt',
                        command: () => {
                            this.login();
                        }
                    },
                    {
                        label: 'Đăng ký',
                        icon: 'fas fa-fw fa-user-plus',
                        routerLink: '/register/check-register'
                    }
                ]
            }
        ];
    }

    clickEvent() {
        this.service.onChangeStatus();
    }

    getStatus(): boolean {
        return this.service.status;
    }

    onChangeStatus() {
        this.service.onChangeStatus();
    }

    isValidAccesstoken() {
        return this._userService.isValidAccessToken();
    }

    login() {
        this._oauthService.loadDiscoveryDocumentAndTryLogin().then(rs => {
            if (!rs) {
                // this._oauthService.customQueryParams = {
                //     'sso': true,
                // };
                this._oauthService.initImplicitFlow();
            }
        });
    }

    getCurrentUserFullName() {
        var organizationInfo = localStorage.getItem(this.CURRENT_USER_KEY);

        if (organizationInfo) {
            const organizationInfoObj = JSON.parse(organizationInfo);
            // this.changeMenuVisibleAfterLoggin();
            // return organizationInfoObj.organizationName ? organizationInfoObj.organizationName : this.rootContext.data.currentUser ? this.rootContext.data.currentUser.fullName : '';
            return organizationInfoObj.fullName;
        }
        return '';
    }

    onTopbarLogout() {
        localStorage.removeItem(this.CURRENT_USER_KEY);
        // this._oauthService.customQueryParams = {
        //     'sso': true,
        // };
        this._authenService.logout();
    }

    onEditInfo(event) {
        // var subDomainClient = environment.clientDomain.subDomainClient;
        // window.location.href = `${subDomainClient}/organization-management/organization-account`;
        event.preventDefault();
    }

    productInfo() {
        this._router.navigate([`organization-management/organization-product`]);
        event.preventDefault();
    }

    plantingAreaInfo() {
        this._router.navigate([`organization-management/organization-planting-area`]);
        event.preventDefault();
    }

    khuInfo() {
        this._router.navigate([`organization-management/organization-khu`]);
        event.preventDefault();
    }

    loInfo() {
        this._router.navigate([`organization-management/organization-lo`]);
        event.preventDefault();
    }

    thuaInfo() {
        this._router.navigate([`organization-management/organization-thua`]);
        event.preventDefault();
    }

    luongInfo() {
        this._router.navigate([`organization-management/organization-luong`]);
        event.preventDefault();
    }

    ferlilizerInfo() {
        this._router.navigate([`organization-management/organization-fertilizer`]);
        event.preventDefault();
    }

    trackFerlilizer() {
        this._router.navigate([`organization-management/track-fertilizer`]);
        event.preventDefault();
    }

    partnerInfo() {
        this._router.navigate([`organization-management/organization-partner`]);
        event.preventDefault();
    }

    stampInfo() {
        this._router.navigate([`organization-management/organization-stamp`]);
        event.preventDefault();
    }

    importInfo() {
        this._router.navigate([`organization-management/organization-import`]);
        event.preventDefault();
    }

    medicineInfo() {
        this._router.navigate([`organization-management/organization-medicine`]);
        event.preventDefault();
    }

    trackMedicine() {
        this._router.navigate([`organization-management/track-medicine`]);
        event.preventDefault();
    }

    staffInfo() {
        this._router.navigate([`organization-management/organization-staff`]);
        event.preventDefault();
    }

    // onServiceManagement() {
    //     var subDomainClient = environment.clientDomain.subDomainClient;
    //     window.location.href = `${subDomainClient}/organization-management/organization-staff`;
    //     event.preventDefault();
    // }
}
